import {Action, State, StateContext, Store} from '@ngxs/store';
import {Injectable, NgZone} from '@angular/core';
import {tap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {append, patch, removeItem, updateItem, insertItem} from '@ngxs/store/operators';
import {Page} from "../models";
import {FetchTree, GetPage, SearchPage} from "./help.actions";
import {HelpService} from "../services/help.service";


export class HelpStateModel {
  public tree: Page[];
  public founded: Page[];
  public loadingTree: boolean;
  public loadingPage: boolean;
  public currentPage: Page;
}


@State<HelpStateModel>({
  name: 'help',
  defaults: {
    tree: [],
    founded: [],
    currentPage: new Page(
      0,
      '',
      '',
      '',
      null,
      null,
      null,
      [],
    ),
    loadingTree: false,
    loadingPage: false,
  }
})
@Injectable()
export class HelpState {

  @Action(FetchTree)
  fetch(ctx: StateContext<HelpStateModel>, action: FetchTree) {
    ctx.patchState({loadingTree: true});

    return this.helpService.fetchTree().pipe(
      tap((response: any) => {
        ctx.patchState({
          tree: response as Page[],
        });
      })
    );
  }

  @Action(GetPage)
  getPage(ctx: StateContext<HelpStateModel>, action: GetPage) {
    ctx.patchState({loadingPage: true});

    return this.helpService.getPage(action.id).pipe(
      tap((response: any) => {
        ctx.patchState({
          currentPage: response as Page,
        });
      })
    );
  }

  @Action(SearchPage)
  searchPage(ctx: StateContext<HelpStateModel>, action: SearchPage) {
    ctx.patchState({loadingPage: true});

    return this.helpService.searchPage(action.text).pipe(
      tap((response: any) => {
        ctx.patchState({
          founded: response as Page[],
        });
      })
    );
  }

  constructor(private helpService: HelpService,
              private store: Store) {
  }

}
